angular.module('env.helpers.injector', [])

    .provider('injector', function () {
        var instanceInjector;

        function get() {
            return instanceInjector;
        }

        function exists() {
            return !!instanceInjector;
        }

        _.extend(this, {
            get: get,
            exists: exists
        });

        this.$get = ['$injector', function ($injector) {
            instanceInjector = $injector;

            return {
                get: get,
                exists: exists
            };
        }];
    })

    .run(function (injector) {
    })
;